// レシピ開閉
$(function () {
  $('.btn_recipe').on('click', function () {
    $(this).prevAll('figure').toggleClass('col1');
    $(this).prevAll('.box_material').slideToggle();
    $(this).prev('.box_recipe').slideToggle();
    $(this).toggleClass('on');
    if ($(this).hasClass('on')) {
      $(this).html('閉じる');
    } else {
      $(this).html('レシピを見る');
    }
  })
})

//
$(function () {
  $(".list_vender_nav a").on("click", function () {
    var sort_label = $(this).data("sort");
    var sort_title = $(this).data("title");
    $(".list_vender_nav a").removeClass("active");
    $(this).addClass("active");
    $(".sort_title").text(sort_title);
    $(".list_vender_card_grid").each(function (index, element) {
      var sort_data = $(this).data(sort_label);
      console.log("sort_data:" + sort_data);
      switch (sort_data) {
        case 5:
          $(this).css("order", "1");
          break;
        case 4:
          $(this).css("order", "2");
          break;
        case 3:
          $(this).css("order", "3");
          break;
        case 2:
          $(this).css("order", "4");
          break;
        case 1:
          $(this).css("order", "5");
          break;
        default:
          $(this).css("order", "5");
      }
    })
  })
})
// box_accordion
$(function () {
  $(".box_accordion .switch span").on("click", function () {
    $(this).parent().prev("div.text").slideToggle();
    var now_class = $(this).attr("class");
    if (now_class == 'open') {
      $(this).attr("class", "close");
    } else {
      $(this).attr("class", "open");
    }
  })
})

// ブランドページ FV
var galleryTop1 = new Swiper(".fvImage__body", {
  loop: true,
  autoplay: {
    delay: 8000,
  },
  centeredSlides: false,
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: {
      el: ".fvImage-thumbs",
      slidesPerView: 5,
      spaceBetween: 5,
    },
  },
  breakpoints: {
    // 768px以上の場合
    767: {
      centeredSlides: true,
      slidesPerView: 1.7,
    },
  },
});

// ブランドページ　レシピ タブタイプ
$(function () {
  $('.block_tab_recipe li:first-of-type').addClass('active');
  $('#recipe_01').fadeIn();
  $('.block_tab_recipe li').on('click', function () {
    // タブ
    $('.block_tab_recipe li').removeClass('active');
    $(this).addClass('active');
    // レシピ
    var select_recipe = $(this).data('recipe');
    $('.box_text_recipe').css('display', 'none');
    $(select_recipe).fadeIn();
  })
})
// ブランドページ　レシピ
var galleryTop2 = new Swiper(".brand_recipe_block", {
  centeredSlides: true,
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 1.1,
      centeredSlides: true,
    },
  },
});
// ブランドページ　スタッフの声
var galleryTop3 = new Swiper(".brand_voice_container", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 15,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
//ブランドページ　QA
$(function () {
  $('.brand_qa .switch').on('click', function () {

  })
})
// box_accordion
$(function () {
  $(".brand_qa .switch span").on("click", function () {
    $(this).parent().prev(".text").toggleClass("open");
    var now_class = $(this).attr("class");
    if (now_class == 'open') {
      $(this).attr("class", "close");
    } else {
      $(this).attr("class", "open");
    }
  })
})

// 特集ページ　レシピ
var galleryTop4 = new Swiper(".feature_recipe_swiper", {
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

// 猪豚放LP 三原則カルーセル
var galleryTop_t3 = new Swiper(".slide_3gensoku_container", {
  slidesPerView: 1,
  spaceBetween: 10,
  slidesPerView: 1.2,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      spaceBetween: 30,
      slidesPerView: 1.5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
});

// 猪豚放LP 商品画像
var galleryTop_item = new Swiper(".lp_cho_item_img", {
  loop: true,
  effect: "fade",
  thumbs: {
    swiper: {
      el: ".lp_cho_item_img_thumb",
      slidesPerView: 5, // サムネイル画像の枚数
      spaceBetween: 5,
    },
  },
});

//ギフトLP　4つの特徴
/*$(function () {
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function () {
    var w = $(window).width();
    if (w <= 768) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('.lp_gift_tokucho', {
          spaceBetween: 0,
          slidesPerView: 1.2,
          pagination: {
            el: ".swiper-pagination", //ページネーションの要素
            type: "bullets", //ページネーションの種類
            clickable: true, //クリックに反応させる
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
});*/

//ギフトLP　バナー
var galleryTop_gift_bnr = new Swiper(".lp_gift_swiper_container", {
  spaceBetween: 10,
  slidesPerView: 1.3,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      spaceBetween: 20,
      slidesPerView: 2,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-lpbnr-next",
        prevEl: ".swiper-button-lpbnr-prev",
      },
    },
  },
});

//ギフトLP　商品
var galleryTop_gift01 = new Swiper(".list_items_01", {
  spaceBetween: 0,
  slidesPerView: 1.2,
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerGroup: 4,
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination", //ページネーションの要素
        type: "bullets", //ページネーションの種類
        clickable: true, //クリックに反応させる
      },
      navigation: {
        nextEl: ".swiper-button-items_01-next",
        prevEl: ".swiper-button-items_01-prev",
      },
    },
  },
});
var galleryTop_gift02 = new Swiper(".list_items_02", {
  spaceBetween: 0,
  slidesPerView: 1.2,
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerGroup: 4,
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination", //ページネーションの要素
        type: "bullets", //ページネーションの種類
        clickable: true, //クリックに反応させる
      },
      navigation: {
        nextEl: ".swiper-button-items_02-next",
        prevEl: ".swiper-button-items_02-prev",
      },
    },
  },
});
var galleryTop_gift03 = new Swiper(".list_items_03", {
  spaceBetween: 0,
  slidesPerView: 1.2,
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerGroup: 4,
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination", //ページネーションの要素
        type: "bullets", //ページネーションの種類
        clickable: true, //クリックに反応させる
      },
      navigation: {
        nextEl: ".swiper-button-items_03-next",
        prevEl: ".swiper-button-items_03-prev",
      },
    },
  },
});
var galleryTop_gift04 = new Swiper(".list_items_04", {
  spaceBetween: 0,
  slidesPerView: 1.2,
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerGroup: 4,
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination", //ページネーションの要素
        type: "bullets", //ページネーションの種類
        clickable: true, //クリックに反応させる
      },
      navigation: {
        nextEl: ".swiper-button-items_04-next",
        prevEl: ".swiper-button-items_04-prev",
      },
    },
  },
});

//ギフトLP　生産者
var galleryTop_gift_vender = new Swiper(".lp_gift_swiper_vender", {
  spaceBetween: 15,
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: ".swiper-button-vender-next",
    prevEl: ".swiper-button-vender-prev",
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 3,
    },
  },
});

//ギフトLP　お届けのイメージ
$(function () {
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function () {
    var w = $(window).width();
    if (w <= 768) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('.lp_gift_swiper_send', {
          spaceBetween: 0,
          slidesPerView: 1,
          pagination: {
            el: ".swiper-pagination", //ページネーションの要素
            type: "bullets", //ページネーションの種類
            clickable: true, //クリックに反応させる
          },
          navigation: {
            nextEl: ".swiper-button-send-next",
            prevEl: ".swiper-button-send-prev",
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
});

//ギフトLP　一度送った送り先の自動保存
$(function () {
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function () {
    var w = $(window).width();
    if (w <= 768) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('.lp_gift_swiper_address', {
          spaceBetween: 0,
          slidesPerView: 1,
          pagination: {
            el: ".swiper-pagination", //ページネーションの要素
            type: "bullets", //ページネーションの種類
            clickable: true, //クリックに反応させる
          },
          navigation: {
            nextEl: ".swiper-button-add-next",
            prevEl: ".swiper-button-add-prev",
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
});

//ギフトLP　領収書の発行
$(function () {
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function () {
    var w = $(window).width();
    if (w <= 768) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('.lp_gift_swiper_receipt', {
          spaceBetween: 0,
          slidesPerView: 1,
          pagination: {
            el: ".swiper-pagination", //ページネーションの要素
            type: "bullets", //ページネーションの種類
            clickable: true, //クリックに反応させる
          },
          navigation: {
            nextEl: ".swiper-button-receipt-next",
            prevEl: ".swiper-button-receipt-prev",
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
});

// お試しセットLP　説明アコーディオン
$(function () {
  $(".box_item:first-of-type .block_accordion").css("display", "flex");
  $(".box_item:first-of-type .btn_accordion").toggleClass("open");
  $(".btn_accordion").on("click", function () {
    $(this).prev(".block_accordion").slideToggle().css("display", "flex");
    $(this).toggleClass("open");
  })
})
